import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import "react-dates/initialize";
import useUniqueId from "../../../../../Hooks/useUniqueId";
import ActivityItemTypeService from "../../../../../../Domain/ActivityItemType/ActivityItemType.service";
import DeprecatedSelect from "../../../../../UI/DeprecatedSelect/DeprecatedSelect";
import DeliveryMethodeService from "../../../../../../Services/DeliveryMethod.service";
export const getItemEventSearchPieceFromMessageFilterState = (state) => {
    if (!state.messageTypes) {
        return null;
    }
    return {
        activityItemTypeIds: [ActivityItemTypeService.Message],
        // @ts-expect-error - TS2322 - Type 'string[]' is not assignable to type 'number[]'.
        types: state.messageTypes && state.messageTypes.map((type) => type.id),
    };
};
const MessageFilters = (props) => {
    var _a;
    const makeId = useUniqueId()[1];
    return (_jsx(_Fragment, { children: _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: makeId("message-types"), className: "sr-only", children: "Message Types" }), _jsx("div", { children: _jsx(DeprecatedSelect.Async, { multi: true, id: makeId("message-types"), placeholder: "Message Types", loadOptions: (search) => DeliveryMethodeService.searchForMessageTab(search).then((options) => ({
                            options,
                        })), value: (_a = props.search) === null || _a === void 0 ? void 0 : _a.messageTypes, valueKey: "id", labelKey: "displayName", onChange: (types) => {
                            props.setSearch((search) => (Object.assign(Object.assign({}, search), { messageTypes: types })));
                        } }) })] }) }));
};
export default MessageFilters;
